<div class="ws-page measurements-page">
  <header class="page-head">
    <div>
      <p class="kicker">Building enforcement</p>
      <div class="page-head-title-row">
        <app-page-back-btn />
        <h2>Measurements</h2>
        <app-page-refresh-btn (refresh)="reload()" />
      </div>
      <p class="muted ws-lead">LiDAR as-built values compared with sanctioned plan and bye-law limits.</p>
    </div>
    <div class="actions">
      <button
        type="button"
        class="btn primary"
        (click)="runRuleCheck()"
        [disabled]="ruleCheckLoading() || filterLocationId() == null"
      >
        {{ ruleCheckLoading() ? 'Running…' : 'Run bye-law check' }}
      </button>
    </div>
  </header>

  <p class="toast" *ngIf="toast()">{{ toast() }}</p>
  <p class="error" *ngIf="error()">{{ error() }}</p>

  <section class="page-card" *ngIf="filterLocationId() as locId">
    <p class="muted filter-note">
      Filtered to location ID <strong>{{ locId }}</strong>.
      <a routerLink="/enforcement/lidar-survey" [queryParams]="{ locationId: locId }">Back to LiDAR Survey</a>
    </p>
  </section>

  <section class="page-card ws-tabs-card measurements-workspace">
    <nav class="ws-tab-bar" role="tablist" aria-label="Measurement views">
      <button
        type="button"
        class="ws-tab"
        role="tab"
        [class.ws-tab-active]="activeTab() === 'all'"
        [attr.aria-selected]="activeTab() === 'all'"
        (click)="setTab('all')"
      >
        All measurements
        <span class="ws-tab-count">{{ rows().length }}</span>
      </button>
      <button
        type="button"
        class="ws-tab"
        role="tab"
        [class.ws-tab-active]="activeTab() === 'compare'"
        [attr.aria-selected]="activeTab() === 'compare'"
        (click)="setTab('compare')"
        [disabled]="!rows().length"
      >
        Plan vs measured vs bye-law
      </button>
    </nav>

    <div class="ws-tab-panel" role="tabpanel" *ngIf="activeTab() === 'all'">
      <p class="muted ws-lead tab-lead">
        Final values after LiDAR processing.
        <a routerLink="/enforcement/lidar-survey">LiDAR Survey</a>
      </p>

      <p class="ws-loading" *ngIf="loading()">Loading measurement records…</p>
      <p class="ws-empty" *ngIf="!loading() && !rows().length">
        No measurements yet. Process a sector scan on LiDAR Survey first.
      </p>

      <div class="table-wrap" *ngIf="!loading() && rows().length">
        <table class="data measurements-table">
          <thead>
            <tr>
              <th>Plot</th>
              <th>Height</th>
              <th>Front setback</th>
              <th>FAR</th>
              <th>Coverage</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of rows()">
              <td><strong class="plot-ref">Khasra {{ r.plotRef }}</strong></td>
              <td class="num">{{ r.heightM }} m</td>
              <td class="num">{{ r.setbackFrontM }} m</td>
              <td class="num">{{ r.farValue }}</td>
              <td class="num">{{ r.groundCoverage }}</td>
              <td class="col-action">
                <span class="compared-badge" *ngIf="isCompared(r.plotRef); else compareBtn">Compared</span>
                <ng-template #compareBtn>
                  <button type="button" class="btn secondary btn-compact" (click)="selectPlot('' + r.plotRef)">
                    Compare
                  </button>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="ws-tab-panel" role="tabpanel" *ngIf="activeTab() === 'compare'">
      <div class="compare-head">
        <div>
          <p class="muted compare-hint">Select a plot to load side-by-side comparison.</p>
        </div>
        <div class="compare-controls">
          <label class="compare-select">
            Plot
            <select
              [ngModel]="selectedPlotRef()"
              (ngModelChange)="onComparePlotPick($event)"
              [disabled]="!rows().length"
            >
              <option *ngFor="let plot of plotOptions()" [value]="plot">Khasra {{ plot }}</option>
            </select>
          </label>
          <button
            type="button"
            class="btn secondary btn-compact"
            (click)="loadCompare()"
            [disabled]="compareLoading() || !selectedPlotRef()"
          >
            {{ compareLoading() ? 'Loading…' : 'Reload compare' }}
          </button>
        </div>
      </div>

      <p class="ws-empty" *ngIf="!loading() && !rows().length">
        No measurements to compare. Process a sector scan on LiDAR Survey first.
      </p>

      <p class="compare-verdict" *ngIf="compareVerdict() && !compareLoading()">
        <strong>Khasra {{ selectedPlotRef() }}:</strong> {{ compareVerdict() }}
      </p>

      <p class="ws-loading" *ngIf="compareLoading()">Loading comparison…</p>

      <div class="table-wrap" *ngIf="!compareLoading() && compareRows().length">
        <table class="data compare-table">
          <thead>
            <tr>
              <th>Check</th>
              <th>Measured (LiDAR)</th>
              <th>Plan (OCR)</th>
              <th>Bye-law limit</th>
              <th>Plan check</th>
              <th>Bye-law check</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of compareRows()">
              <td>{{ r.field }}</td>
              <td class="num">{{ formatValue(r.measured, r.unit) }}</td>
              <td class="num">{{ formatValue(r.plan, r.unit) }}</td>
              <td class="num">{{ formatValue(r.byeLawLimit, r.unit) }}</td>
              <td>
                <span class="compare-pill" [ngClass]="statusClass(r.planStatus)">
                  {{ r.planStatus || 'n/a' }}
                </span>
              </td>
              <td>
                <span class="compare-pill" [ngClass]="statusClass(r.byeLawStatus)">
                  {{ r.byeLawStatus || 'n/a' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>
